module.exports = __webpack_public_path__ + "static/media/profmegh.62670a29.png";